<!-- VUE VERSION FOR _card_list.html.erb with collapsable option -->
<template>
  <div class="card">
    <header
      v-if="hasHeader"
      class="card-header h5 d-flex align-items-center justify-content-between"
      :class="{ 'border-bottom-0': closed }"
      :role="collapsable ? 'button' : 'none'"
      :data-bs-toggle="collapsable ? 'collapse' : ''"
      :data-bs-target="`#collapsable_card_${randomKey}`"
      :aria-expanded="!startCollapsed"
      :aria-controls="`collapsable_card_${randomKey}`"
      :data-current-state="closed.toString()"
      @click="updateStatus($event)"
    >
      <slot name="header" />
      <AVIcon v-if="collapsable" :icon="closed ? 'maximize' : 'minimize'" class="text-dark" />
    </header>
    <div
      :class="{
        'show': collapsable && !startCollapsed,
        'collapse': collapsable,
        'list-group': list,
        'list-group-flush': list,
        'overflow-auto': list,
      }"
      :id="`collapsable_card_${randomKey}`"
      :style="bodyStyles"
    >
      <slot name="body" />
    </div>
      <footer v-if="hasFooter" class="card-footer">
        <slot name="footer" />
      </footer>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, useSlots } from "vue";
const slots = useSlots();

const props = defineProps({
  maxHeight: {
    type: Number,
    default: null,
  },
  collapsable: {
    type: Boolean,
    default: false,
  },
  startCollapsed: {
    type: Boolean,
    default: false,
  },
  list: {
    type: Boolean,
    default: false,
  },
});

const closed = ref<boolean>(props.startCollapsed);

const updateStatus = (event: Event) => {
  if (!props.collapsable) return;
  closed.value = (event.target as HTMLButtonElement).dataset.currentState === "false";
};

const hasHeader = computed(() => !!slots.header);

const hasFooter = computed(() => !!slots.footer);

const bodyStyles = computed(() => props.maxHeight ? `max-height: ${props.maxHeight}px;` : "");

const randomKey = computed(() => (Math.random() + 1).toString(36).substring(2));
</script>
